/** CSS contract: css-library/components/02-containers/pill.css. */
import type { Ref } from 'react';
import { useState } from 'react';
import type { HTMLAttributes } from 'react';
import { ButtonControl } from './ButtonControl';
import { Icon } from './Icon';
import { Menu } from './Menu';
import { cx } from '../lib/cx';

export interface ViewTypeControlOption {
  value: string;
  label: string;
  icon: string;
}

export interface ViewTypeControlProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  options: ViewTypeControlOption[];
  value: string;
  onChange: (value: string) => void;
  label: string;

}

export function ViewTypeControl(
  { ref, options, value, onChange, label, className, ...rest }: ViewTypeControlProps & { ref?: Ref<HTMLButtonElement> },
) {
  const [open, setOpen] = useState(false);
  const glyph = (options.find((option) => option.value === value) ?? options[0])?.icon;
  return <Menu ref={ref} className={cx('view-type-control', className)} {...rest}
    presentation="pill" retainTrigger panelRole="listbox" open={open} onOpenChange={setOpen}
    trigger={glyph && <Icon name={glyph} />}
    triggerButtonProps={{ iconOnly: true, 'aria-label': label, title: label }}>
    {options.map((option) => <ButtonControl key={option.value} type="button" role="option"
      aria-selected={option.value === value} className={cx('btn pill-menu-option', option.value === value && 'is-active', option.value === value && 'is-selected')}
      onClick={() => { onChange(option.value); setOpen(false); }}>
      <Icon name={option.icon} /><span>{option.label}</span>
    </ButtonControl>)}
  </Menu>;
}
